import DocsLink from '../../generic/Link/DocsLink';
import Text from '../../generic/Text';

/**
 *  Terms & Conditions link + text for the AuthForm.
 */
const AuthFormTermsLink = () => (
  <div className="fossa-auth__form__terms-link">
    <Text.Paragraph>
      <div className="margin-bottom-xs">
        By signing up, I accept the FOSSA
      </div>
      <DocsLink to="terms-of-service">
        Terms and Conditions
      </DocsLink>
    </Text.Paragraph>
  </div>
);

export default AuthFormTermsLink;
